import type { LoginPayload, ForgotPasswordPayload, ResetPasswordPayload, ApiSuccess, AcceptInvitePayload, ResolvedBranding, InvitationType } from '@lkq/shared';
import { api } from './api';
import type { MePayload } from '@/types/entities';

export async function login(payload: LoginPayload): Promise<MePayload> {
  const { data } = await api.post<ApiSuccess<MePayload>>('/auth/login', payload);
  return data.data;
}

export async function fetchMe(): Promise<MePayload> {
  const { data } = await api.get<ApiSuccess<MePayload>>('/auth/me');
  return data.data;
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout');
}

export async function forgotPassword(payload: ForgotPasswordPayload): Promise<void> {
  await api.post('/auth/forgot-password', payload);
}

export async function resetPassword(payload: ResetPasswordPayload): Promise<void> {
  await api.post('/auth/reset-password', payload);
}

export interface InvitationDescription {
  type: InvitationType;
  email: string;
  firstName: string | null;
  lastName: string | null;
  garageName: string | null;
  conceptName: string | null;
  branding: ResolvedBranding;
}

export async function describeInvitation(token: string): Promise<InvitationDescription> {
  const { data } = await api.get<ApiSuccess<InvitationDescription>>(`/invitations/${token}`);
  return data.data;
}

export async function acceptInvitation(
  token: string,
  payload: AcceptInvitePayload,
): Promise<{ redirect: string; isGarageUser: boolean; membershipStatus: string | null }> {
  const { data } = await api.post<ApiSuccess<{ redirect: string; isGarageUser: boolean; membershipStatus: string | null }>>(
    `/invitations/${token}/accept`,
    payload,
  );
  return data.data;
}
